module.exports = __webpack_public_path__ + "黑铁-57d6708a.png";